import classnames from "classnames";

import styles from "./CircleIcon.module.scss";

interface CircleIconProps {
  num: number;
  className?: string;
}

export const CircleIcon = ({ num, className }: CircleIconProps) => {
  return (
    <span className={classnames(className, styles.circle_icon)}>
      <span>{num}</span>
    </span>
  );
};

export function getBedBathCount(
  bedroomCounter: number,
  bedCounter: number,
  bathroomCounter: number,
) {
  let count = 0;
  if (bedroomCounter > 0) {
    count++;
  }
  if (bedCounter > 1) {
    count++;
  }
  if (bathroomCounter > 1) {
    count++;
  }
  return count;
}
